export default __webpack_public_path__ + "static/media/轮播首图12.a0f1165f.jpg";